module.exports = __webpack_public_path__ + "img/no-avatar.406cab90.jpg";